export default {
    GET_RESERVATION_REQUEST: 'RESERVATION_GET_RESERVATION_REQUEST',
    GET_RESERVATION_SUCCESS: 'RESERVATION_GET_RESERVATION_SUCCESS',
    DESTROY_RESERVATION_REQUEST: 'RESERVATION_DESTROY_RESERVATION_REQUEST',
    DESTROY_RESERVATION_SUCCESS: 'RESERVATION_DESTROY_RESERVATION_SUCCESS',
    UPDATE_RESERVATION_REQUEST: 'RESERVATION_UPDATE_RESERVATION_REQUEST',
    UPDATE_RESERVATION_SUCCESS: 'RESERVATION_UPDATE_RESERVATION_SUCCESS',
    DISPOSE: 'RESERVATION_DISPOSE_STORE',
};
